__turbopack_context__.v({
  "bar": "ProgressBar-module__Ev-c4G__bar",
  "fill": "ProgressBar-module__Ev-c4G__fill",
  "fillBlue": "ProgressBar-module__Ev-c4G__fillBlue",
  "fillGreen": "ProgressBar-module__Ev-c4G__fillGreen",
  "fillPlaceholder": "ProgressBar-module__Ev-c4G__fillPlaceholder",
  "fillRed": "ProgressBar-module__Ev-c4G__fillRed",
});
